Vue.component('extra-info-box', {
  template: '#vue-extra-info-box',
  props: {
    type: { default: 'email' }
  },
  data: function () {
    return {
      params: {
        city: '',
        email: ''
      },
      listCities: []
    }
  },
  created: function () {
    if (this.type === 'biura') {
      this.getCities();
    }
  },
  watch: {
    'params.city': function (newType, oldType) {
      if (newType != oldType) {
        router.push({ name: 'biura-agencyjne', params: { city: newType } });
      }
    }
  },
  methods: {
    getCities: function () {
      const self = this;
      $.post("/back/BiuraAgencyjne.php", { action: 'list' }, function (result) {
        if (result !== null) {
          self.listCities = result;
        }
      }, "json");
    },
    validateEmail: function (email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    saveNewsLetter: function () {
      const self = this;

      if (self.validateEmail(self.params.email) === false) {
        alert(locales('components.extra-info-box.js.error_email'));
        return;
      }

      if (agentx == "kompasoasis2www") { // agentx == "kompas2www" || 
        if (confirm('Wyrażam zgodę na przetwarzanie moich danych osobowych (adresu e-mail) w związku z art. 6 ust. 1 lit. a) rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO). W każdym momencie mogę wycofać zgodę wypisując się z newslettera.')) {
          // Save
          $.post("/back/NewsLetter.php", { email: self.params.email }, function (result) {
            alert(result.details);
            self.params.email = '';
          }, "json");
        }
      } else {
        $.post("/back/NewsLetter.php", { email: self.params.email }, function (result) {
          alert(result.details);
          self.params.email = '';
        }, "json");
      }
    }
  }
});
